"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTIF_CLEAR = exports.NOTIF_DISMISS = exports.NOTIF_SEND = void 0;
var loopback_error_parser_1 = require("loopback-error-parser");
exports.NOTIF_SEND = 'NOTIF_SEND';
exports.NOTIF_DISMISS = 'NOTIF_DISMISS';
exports.NOTIF_CLEAR = 'NOTIF_CLEAR';
var dismissAfter = 3500;
var RednotAction = (function () {
    function RednotAction() {
    }
    RednotAction.notif = function (className) {
        return function (message) { return function (dispatch) {
            dispatch(RednotAction.notifSend({ message: message, dismissAfter: dismissAfter, className: className }));
        }; };
    };
    RednotAction.notifClear = function () {
        return { type: exports.NOTIF_CLEAR };
    };
    RednotAction.notifDismiss = function (id) {
        return { type: exports.NOTIF_DISMISS, payload: id };
    };
    RednotAction.notifSend = function (notif) {
        var payload = notif;
        if (!payload.id)
            payload.id = new Date().getTime();
        return function (dispatch) {
            dispatch({ type: exports.NOTIF_SEND, payload: payload });
            if (payload.dismissAfter) {
                setTimeout(function () {
                    dispatch({
                        type: exports.NOTIF_DISMISS,
                        payload: payload.id,
                    });
                }, payload.dismissAfter);
            }
        };
    };
    RednotAction.error = RednotAction.notif('alert alert-danger');
    RednotAction.success = RednotAction.notif('alert alert-primary');
    RednotAction.onError = function (e, dispatch) {
        return dispatch(RednotAction.error(loopback_error_parser_1.getErrorMessage(e)));
    };
    return RednotAction;
}());
exports.default = RednotAction;
//# sourceMappingURL=RednotAction.js.map